const debounceFn = require('debounce-fn');

const currentYear = new Date().getFullYear();

const appendZero = function(number) {
  return number > 9 ? number : 0 + "" + number;
};
const dateToString = function (date) {
  return date.getFullYear() + '-' + appendZero(date.getMonth()+1) + '-' + appendZero(date.getDate());
};

class DatePicker{
  constructor($filter, $scope, $element, $timeout) {
    'ngInject';
    this.$filter = $filter;
    this.$scope = $scope;
    this.$timeout = $timeout;
    const dpElemLite = $element.find('.mydate');
    this.dpElem = window.jQuery(dpElemLite); // Explicitly wrap with jQuery
    this.isTyping = false;
    this.isFocused = false;
  }

  $onInit(){
    this.debounce = this.sDebounce || 1500;
    this.sShowOnFocus = this.sShowOnFocus === undefined ? true : this.sShowOnFocus;
    this.debounceInputChange = debounceFn(this.onDebouncedInputChange, {wait: this.debounce});

    this.dpElem.datepicker({
      format: 'dd/mm/yyyy',
      todayBtn: 'linked',
      language: "nl",
      autoclose: true,
      forceParse: false,
      startDate: this.sMinDate,
      endDate: this.sMaxDate,
      showOnFocus: this.sShowOnFocus,
      todayHighlight: true,
      orientation: this.orientation ? this.orientation : 'top auto',
      weekStart: 1
    });

    if (this.date) {
      this.dateInput = this.dateFilter(this.date);
    }

    this.dpElem.datepicker().on('changeDate', e => {
      //This event is also fired every time when the text input changes. We capture this with the ng-on-change on the input field.
      if(!this.isFocused) {
        this.$scope.$apply(() => {
          this.date = e.format(0, 'yyyy-mm-dd');
          this.emitEvent(true);
        });
      }
    });

    this.dpElem.datepicker().on('show', e => {
      this.$scope.$apply(() => {
        this.isTyping = true;
        this.$scope.$emit('kovFormElemStartTyping', this.sModel);
      });
    });

    this.dpElem.datepicker().on('hide', e => {
      this.$scope.$apply(() => {
        this.isTyping = false;
        this.$scope.$emit('kovFormElemStopTyping', this.sModel);
      });
    });

    /* this.$scope.$watch('ctrl.date', (val, old) => {
      //When the date is changed, by changing the s-model from the outer scope.
      if(!this.isFocused && val !== old && this.dateInput !== this.dateFilter(this.date)) {
        console.log('DP: datewatcher - date is changed while no longer focused');
        this.dateInput = this.dateFilter(this.date);
        this.emitEvent(true);
      };

      /!*var dpDate = this.dpElem.datepicker('getDate');
      if(!dpDate || (val && val !== dateToString(dpDate))) {
        this.dpElem.datepicker('update', this.dateFilter(val));
      }*!/
    }); */

    if(this.sValidate && !Array.isArray(this.sValidate)) {
      this.sValidate = [this.sValidate];
    }

    const validationErrors = this.validate(true);
    this.$scope.$emit('kovFormElemChanged', {
      onInitPhase: true,
      value: this.sModel,
      errors: validationErrors
    });

    // broadcast event from component that uses form to indicate that a new entity is selected and form needs to be reset (no errors from previous enitity should be left hanging)
    /* this.$scope.$on('resetFormValidation', () => {
      this.validatedSinceReset = false;
      this.$timeout(() => {
        // give time for bindings to be set
        if (!this.validatedSinceReset) {
          // When a new entity is loaded in the form and this formcomponent is empty or hidden on the screen we need to make sure it is validated again.
          const validationErrors = this.validate(true);
          this.$scope.$emit('kovFormElemChanged', {
            onInitPhase: true,
            value: this.sModel,
            errors: validationErrors
          });
        }
      }, 1500);
    }); */
  }

  $onChanges(bindings){
    if (bindings.date && !bindings.date.currentValue && bindings.date.previousValue && !this.isFocused && this.dateInput) {
      this.dateInput = null;
    }
    if(bindings.date && bindings.date.currentValue) {
      // console.log('Ik krijg hier een on-change event voor date', bindings);
      if(!this.isFocused && bindings.date.currentValue !== bindings.date.previousValue && this.dateInput !== this.dateFilter(this.date)) {
        // console.log('DP: datewatcher - date is changed while no longer focused');
        this.dateInput = this.dateFilter(this.date);
        const validationErrors = this.validate(true);
        this.$scope.$emit('kovFormElemChanged', {
          value: this.date,
          errors: validationErrors
        });
      };
    }
  }

  // When A key is pressed we will trye to help user constructing a valid date. Add a / so he only has to type numbers and add leading zero's
  onKeyUp(event) {
    //console.log('keyup: keyCode ', event.keyCode);
    if(event.keyCode === 191 || event.keyCode === 111) {
      // When typing a '/'
      if(this.dateInput.match(/^\d{1}\/$/g)) {
        this.dateInput = appendZero(this.dateInput.charAt(0)) + '/';
      } else if(this.dateInput.match(/^\d{2}\/\d{1}\/$/g)) {
        this.dateInput = this.dateInput.substring(0,3) + appendZero(this.dateInput.charAt(3)) + '/';
      }
    } else if((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105)) {
      // When typing a number 0-9
      if(this.dateInput.match(/^[0-3][0-9]$/g) || this.dateInput.match(/^[0-3][0-9]\/(0[1-9]|1[0-2])$/g)) {
        this.dateInput += '/';
      }
    }
  }

  keyPressed(event) {
    /*console.log('keypress: keyCode ', event.keyCode)
    console.log('keypress: keyChar ', String.fromCharCode(event.keyCode))*/
    if(event.keyCode === 191 || event.keyCode === 111) {
      // When typing a '/' that is aleady there.
      if(this.dateInput.match(/^[0-3][0-9]\/$/g) || this.dateInput.match(/^[0-3][0-9]\/(0[1-9]|1[0-2])\/$/g)) {
        event.preventDefault();
      }
    }
    if(!this.isTyping) {
      this.isTyping = true;
      this.$scope.$emit('kovFormElemStartTyping', this.sModel);
    }
  }

  onChangeEmitter() {
    if(this.isFocused) {
      this.debounceInputChange();
    }
  };

  onFocus() {
    this.isFocused = true;
  };
  onBlur(){
    this.isFocused = false;
    this.debounceInputChange.cancel();
    //If the user leaves the date picker with only two digits for the year we will add the millenium and century for him.
    if(this.dateInput && this.dateInput.match(/^\d{2}\/\d{2}\/\d{2}$/g)) {
      this.dateInput = this.dateInput.substring(0,6) + ((parseInt(this.dateInput.substring(6,8)) - 1).toString() <= currentYear.toString().substring(2,4) ? '20' : '19') + this.dateInput.substring(6,8);
    }
    this.dateInputChanged();
  }

  dateFilter(date){
    return this.$filter('date')(date, "dd/MM/yyyy");
  }

  // After debounced time ellapsed. Because we left angular we need to trigger digest.
  onDebouncedInputChange() {
    this.$scope.$apply(() => {
      this.dateInputChanged();
    });
  }

  /*
    If the dateInput is not of the right format dd/mm/yyyy, we will do no effort in trying to transform it to the api format yyyy-mm-dd
    This is why we will send undefined to the onChange event.
  */
  dateInputChanged() {
    this.isTyping = false;
    const validationErrors = this.validateRequiredAndFormat();
    if(validationErrors) {
      this.$scope.$emit('kovFormElemChanged', {
        value: this.date,
        errors: validationErrors
      });
      this.$scope.$emit('onChange', undefined);
    } else {
      if (this.dateInput) {
        this.date = this.dateInput.split('/').reverse().join('-');
      } else {
        this.date = undefined;
      }
      this.emitEvent();
    }
  }

  emitEvent(validateRequiredAndFormat){
    const validationErrors = this.validate(validateRequiredAndFormat);
    this.$scope.$emit('kovFormElemChanged', {
      value: this.date,
      errors: validationErrors
    });
    this.$scope.$emit('onChange', this.date);
  }

  isValidDate(day, month, year) {
    if(month > 12) {
      return false;
    }
    if(month === 2) {
      return day <= 29;
    } else if([4, 6, 9, 11].some(val => val === month)) {
      return day <= 30;
    } else {
      return day <= 31;
    }
  }

  isValidDateInputFormat() {
    if(!this.dateInput.match(/^\d{2}\/\d{2}\/\d{4}$/g)) {
      return false;
    }
    const words = this.dateInput.split('/');
    return this.isValidDate(words[0], words[1], words[2]);
  }

  isFormatValid() {
    if(!this.date.match(/^\d{4}\-\d{2}\-\d{2}$/g)) {
      return false;
    }
    const words = this.date.split('-');
    return this.isValidDate(words[2], words[1], words[0]);
  }

  validateRequiredAndFormat() {
    if(this.sRequired && !this.dateInput) {
      return [{
        code: 'required',
        message: this.sRequired.message
      }];
    }
    if(this.dateInput && !this.isValidDateInputFormat()) {
      return [{code: 'pattern.date'}];
    }
  }

  /* When changing the dateInput it will first check required and format properties in dateInputFormat dd/mm/yyyy.
  No need to check it again after  transforming it to api input yyyy-mm-dd*/
  validate(validateRequiredAndFormat) {
    this.validatedSinceReset = true;
    const errors = [];
    if(validateRequiredAndFormat) {
      if(this.sRequired && !this.date) {
        return [{
          code: 'required',
          message: this.sRequired.message
        }];
      }
      if(!this.date) {
        return [];
      }
      if(!this.isFormatValid()) {
        return [{code: 'pattern.date'}];
      }
    }
    if(!this.date) {
      return [];
    }
    if(this.sMinDate) {
      const minDate = this.sMinDate.minDate || this.sMinDate;
      if(this.date < minDate) {
        errors.push({code: 'min.value', minValue: this.dateFilter(this.sMinDate), message: this.sMinDate.message});
      }
    }
    if(this.sMaxDate) {
      const maxDate = this.sMaxDate.maxDate || this.sMaxDate;
      if(this.date > maxDate) {
        errors.push({code: 'max.value', maxValue: this.dateFilter(this.sMaxDate), message: this.sMaxDate.message});
      }
    }
    if(this.sValidate) {
      this.sValidate.forEach(validateObj => {
        const validateFunction = validateObj.validate || validateObj;
        const extraArguments = validateObj.args ? validateObj.args : [];
        const error = validateFunction(this.date, ...extraArguments);
        if(error) {
          errors.push({
            code: error.code,
            message: error.message
          });
          if(error.stopValidation) {
            return errors;
          }
        }
      });
    }
    return errors;
  }
}

module.exports = {
  template: require('./kovDatePicker.html'),
  controllerAs: 'ctrl',
  bindings: {
    date: '<sModel',
    sMinDate: '<',
    sMaxDate: '<',
    sRequired: '<',
    sDisabled: '<',
    sDebounce: '<',
    sValidate: '<',
    orientation: '@sOrientation',
    sShowOnFocus: '<'
  },
  controller: DatePicker
};
